import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  Drawer,
  IconButton,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../Sidebar";
import MenuIcon from "@mui/icons-material/Menu";

// Import all resume components
import Resume1 from "../DuplicateResume/Resume1";
import Resume2 from "../DuplicateResume/Resume2";
import Resume3 from "../DuplicateResume/Resume3";
import Resume4 from "../DuplicateResume/Resume4";
import Resume5 from "../DuplicateResume/Resume5";
import Resume6 from "../DuplicateResume/Resume6";
import Resume7 from "../DuplicateResume/Resume7";
import Resume8 from "../DuplicateResume/Resume8";
import Resume9 from "../DuplicateResume/Resume9";
import Resume10 from "../DuplicateResume/Resume10";
import Resume11 from "../DuplicateResume/Resume11";
import Resume12 from "../DuplicateResume/Resume12";
import Resume13 from "../DuplicateResume/Resume13";
import Resume14 from "../DuplicateResume/Resume14";
import Resume15 from "../DuplicateResume/Resume15";
import Resume16 from "../DuplicateResume/Resume16";
import Resume17 from "../DuplicateResume/Resume17";
import Resume18 from "../DuplicateResume/Resume18";
import Resume19 from "../DuplicateResume/Resume19";
import Resume21 from "../DuplicateResume/Resume21";
import Resume22 from "../DuplicateResume/Resume22";
import Resume23 from "../DuplicateResume/Resume23";
import Resume24 from "../DuplicateResume/Resume24";
import Resume25 from "../DuplicateResume/Resume25";
import Resume26 from "../DuplicateResume/Resume26";
import Resume27 from "../DuplicateResume/Resume27";
import Resume28 from "../DuplicateResume/Resume28";
import Resume29 from "../DuplicateResume/Resume29";
import Resume30 from "../DuplicateResume/Resume30";
import Resume31 from "../DuplicateResume/Resume31";
import Resume32 from "../DuplicateResume/Resume32";
import Resume33 from "../DuplicateResume/Resume33";
import Resume34 from "../DuplicateResume/Resume34";
import Resume35 from "../DuplicateResume/Resume35";
import Resume36 from "../DuplicateResume/Resume36";

import Resume37 from "../DuplicateResume/Resume37";
import Resume38 from "../DuplicateResume/Resume38";
import Resume39 from "../DuplicateResume/Resume39";
import Resume40 from "../DuplicateResume/Resume40";
import Resume41 from "../DuplicateResume/Resume41";
import Resume42 from "../DuplicateResume/Resume42";
import Resume43 from "../DuplicateResume/Resume43";
import Resume44 from "../DuplicateResume/Resume44";
import Resume45 from "../DuplicateResume/Resume45";
import Resume46 from "../DuplicateResume/Resume46";
import Resume47 from "../DuplicateResume/Resume47";
import Resume48 from "../DuplicateResume/Resume48";
import Resume49 from "../DuplicateResume/Resume49";
import Resume50 from "../DuplicateResume/Resume50";

const templateComponents = {
  1: Resume1,
  2: Resume2,
  3: Resume3,
  4: Resume4,
  5: Resume5,
  6: Resume6,
  7: Resume7,
  8: Resume8,
  9: Resume9,
  10: Resume10,
  11: Resume11,
  12: Resume12,
  13: Resume13,
  14: Resume14,
  15: Resume15,
  16: Resume16,
  17: Resume17, 
  18: Resume18,
  19: Resume19,
  21: Resume21,  
  22: Resume22,     
  23: Resume23,     
  24: Resume24,     
  25: Resume25,     
  26: Resume26,
  27: Resume27,
  28: Resume28,
  29: Resume29,
  30: Resume30,
  31: Resume31,
  32: Resume32,
  33: Resume33,
  34: Resume34,
  35: Resume35,
  36: Resume36,
  37: Resume37,
  38: Resume38,
  39: Resume39,
  40: Resume40,
  41: Resume41,
  42: Resume42,
  43: Resume43,
  44: Resume44,
  45: Resume45,
  46: Resume46,
  47: Resume47,
  48: Resume48,
  49: Resume49,
  50: Resume50,
};

const ResumeStepPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [selectedTemplate, setSelectedTemplate] = useState(1);
  const [selectedTheme, setSelectedTheme] = useState("#1a2b47");
  const [selectedPurpose, setSelectedPurpose] = useState(null);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const handleChoice = async (purpose) => {
    setSelectedPurpose(purpose);
    try {
      const res = await fetch("https://resume-maker-lc.onrender.com/api/resume-reason", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ purpose }),
      });
      const data = await res.json();
      console.log("Saved Purpose:", data);
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Fetch selected template & theme from location.state
  useEffect(() => {
    if (location.state) {
      const { selectedTemplate: template, selectedTheme: theme } = location.state;
      if (template) setSelectedTemplate(template);
      if (theme) setSelectedTheme(theme);
    }
  }, [location.state]);

  const SelectedResumeComponent = templateComponents[selectedTemplate];

  const getResumeProps = () => {
    switch (selectedTemplate) {
      case 2:
        return { color: selectedTheme };
      case 3:
        return {
          color: typeof selectedTheme === "object" ? selectedTheme.primary : selectedTheme,
        };
      case 4:
        return {
          theme: selectedTheme,
          color: typeof selectedTheme === "object" ? selectedTheme.primary : selectedTheme,
        };
      case 7:
        return {
          theme: selectedTheme,
          color: typeof selectedTheme === "object" ? selectedTheme.highlight : selectedTheme,
        };
      case 8:
        return { theme: selectedTheme };
      default:
        return { color: selectedTheme };
    }
  };

  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  // Handle Go Back navigation to HeadingContactPage
  const handleGoBack = () => {
    navigate("/HeadingContactPage", {
      state: { selectedTemplate, selectedTheme },
    });
  };

  return (
    <Box display="flex" minHeight="100vh" sx={{ backgroundColor: "#EFF7FF" }}>
      {/* Desktop Sidebar */}
      {!isMobile && <Sidebar />}

      {/* Mobile Sidebar Drawer */}
      {isMobile && (
        <>
          {/* Hamburger Menu Button */}
          <IconButton
            onClick={toggleMobileSidebar}
            sx={{
              position: "fixed",
              top: 16,
              left: 16,
              zIndex: 1300,
              backgroundColor: "#ffffff",
              boxShadow: "0 2px 8px rgba(0, 43, 91, 0.2)",
              color: "#002B5B",
              "&:hover": {
                backgroundColor: "#E1F5FE",
              },
            }}
          >
            <MenuIcon />
          </IconButton>

          {/* Mobile Drawer */}
          <Drawer
            variant="temporary"
            open={mobileSidebarOpen}
            onClose={toggleMobileSidebar}
            ModalProps={{
              keepMounted: true, // Better mobile performance
            }}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: 280,
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <Sidebar onMobileClose={toggleMobileSidebar} />
          </Drawer>
        </>
      )}

      {/* Main Content */}
      <Container 
        maxWidth="md" 
        sx={{ 
          p: isSmallMobile ? 2 : isMobile ? 3 : 5,
          width: "100%",
          marginLeft: isMobile ? 0 : "auto",
          marginRight: isMobile ? 0 : "auto",
          pt: isMobile ? 8 : 5, // Add top padding for mobile to account for hamburger menu
        }}
      >
        {/* Go Back Button */}
        <Typography
          variant="body2"
          sx={{
            color: "#002B5B",
            fontWeight: "bold",
            mb: 2,
            cursor: "pointer",
            "&:hover": {
              color: "#0288D1",
              textDecoration: "underline",
            },
            transition: "color 0.3s ease",
            fontSize: isSmallMobile ? "0.875rem" : "inherit",
          }}
          onClick={handleGoBack}
        >
          ← Go Back
        </Typography>

        <Typography 
          variant={isMobile ? "h6" : "h5"} 
          fontWeight="bold" 
          textAlign="center" 
          gutterBottom
          sx={{
            fontSize: isSmallMobile ? "1.25rem" : "inherit",
            color: "#002B5B",
          }}
        >
          Why do you need a resume?
        </Typography>
        <Typography 
          variant="body1" 
          textAlign="center"
          gutterBottom
          sx={{ 
            fontSize: isSmallMobile ? "0.875rem" : "inherit",
            px: isSmallMobile ? 1 : 0,
            color: "#0288D1",
          }}
        >
          We'll show you a personalized experience based on your response.
        </Typography>

        {/* Choices */}
        <Box 
          sx={{ 
            display: "flex", 
            justifyContent: "center", 
            gap: 2, 
            mt: 4,
            flexDirection: isSmallMobile ? "column" : "row",
            alignItems: "center",
          }}
        >
          <Button
            variant={selectedPurpose === "Job Seeking" ? "contained" : "outlined"}
            sx={{ 
              width: isSmallMobile ? "100%" : 220,
              maxWidth: isSmallMobile ? "280px" : "none",
              height: 60, 
              fontSize: isSmallMobile ? "0.9rem" : "1rem", 
              borderRadius: 2,
              fontWeight: "bold",
              borderColor: selectedPurpose === "Job Seeking" ? "transparent" : "#0288D1",
              backgroundColor: selectedPurpose === "Job Seeking" ? "#002B5B" : "transparent",
              color: selectedPurpose === "Job Seeking" ? "#ffffff" : "#002B5B",
              "&:hover": {
                backgroundColor: selectedPurpose === "Job Seeking" ? "#0288D1" : "#E1F5FE",
                borderColor: "#002B5B",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(0, 43, 91, 0.25)",
                transition: "all 0.3s ease",
              },
              transition: "all 0.3s ease",
            }}
            onClick={() => handleChoice("Job Seeking")}
          >
            Job Seeking
          </Button>

          <Button
            variant={selectedPurpose === "Different Reason" ? "contained" : "outlined"}
            sx={{ 
              width: isSmallMobile ? "100%" : 220,
              maxWidth: isSmallMobile ? "280px" : "none",
              height: 60, 
              fontSize: isSmallMobile ? "0.9rem" : "1rem", 
              borderRadius: 2,
              fontWeight: "bold",
              borderColor: selectedPurpose === "Different Reason" ? "transparent" : "#0288D1",
              backgroundColor: selectedPurpose === "Different Reason" ? "#002B5B" : "transparent",
              color: selectedPurpose === "Different Reason" ? "#ffffff" : "#002B5B",
              "&:hover": {
                backgroundColor: selectedPurpose === "Different Reason" ? "#0288D1" : "#E1F5FE",
                borderColor: "#002B5B",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(0, 43, 91, 0.25)",
                transition: "all 0.3s ease",
              },
              transition: "all 0.3s ease",
            }}
            onClick={() => handleChoice("Different Reason")}
          >
            A Different Reason
          </Button>
        </Box>

        {/* Skip / Next */}
        <Box
          sx={{
            mt: isMobile ? 4 : 6,
            display: "flex",
            justifyContent: isSmallMobile ? "space-between" : "flex-end",
            alignItems: "center",
            gap: 3,
            flexDirection: isSmallMobile ? "column" : "row",
          }}
        >
          <Typography
            variant="body2"
            sx={{ 
              color: "#0288D1", 
              fontWeight: "bold", 
              cursor: "pointer",
              "&:hover": {
                color: "#002B5B",
                textDecoration: "underline",
                transition: "color 0.3s ease",
              },
              transition: "color 0.3s ease",
              textAlign: isSmallMobile ? "center" : "left",
              width: isSmallMobile ? "100%" : "auto",
            }}
            onClick={() =>
              navigate("/WorkHistry1", { state: { selectedTemplate, selectedTheme } })
            }
          >
            Skip for now
          </Typography>

          <Button
            variant="contained"
            sx={{
              px: isSmallMobile ? 3 : 5,
              borderRadius: 3,
              fontWeight: "bold",
              height: 45,
              backgroundColor: "#002B5B",
              width: isSmallMobile ? "100%" : "auto",
              maxWidth: isSmallMobile ? "200px" : "none",
              "&:hover": { 
                backgroundColor: "#0288D1",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(0, 43, 91, 0.35)",
                transition: "all 0.3s ease",
              },
              transition: "all 0.3s ease",
            }}
            onClick={() =>
              navigate("/WorkHistry1", { state: { selectedTemplate, selectedTheme } })
            }
          >
            Next
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default ResumeStepPage;